import { useEffect, useState } from 'react'

import { CustomerApi } from '../api'
import { captureException } from '../utils/sentry'

export default function useClassifications() {
  const [loadingClassifications, setLoadingClassifications] = useState(false)
  const [classifications, setClassifications] = useState([])
  const [classificationsFailed, setClassificationsFailed] = useState(false)

  const fetchClassifications = () => {
    setLoadingClassifications(true)
    setClassificationsFailed(false)

    CustomerApi.get('/classifications')
      .then(({ data }: any) => {
        const leadOptions = data.map((classification: any) => ({
          label: classification.name,
          value: classification.id
        }))
        setClassifications(leadOptions)
      })
      .catch((error: any) => {
        setClassificationsFailed(true)
        captureException(error, { tags: { location: 'fetchClassifications-notificationSettings' } })
      })
      .finally(() => {
        setLoadingClassifications(false)
      })
  }

  useEffect(() => {
    fetchClassifications()
  }, [])

  return { loadingClassifications, classifications, classificationsFailed, fetchClassifications }
}
